__turbopack_context__.v({
  "logo": "sB9DGq_logo",
});
